import React from 'react';

// =============================================
// Tela do Estúdio — a moldura de toda tela de trabalho (mesma da Central de
// Compras do comercial, components/compras/Tela.js): ocupa a altura inteira da
// janela; título e abas numa linha só no topo, ações à direita; quem rola é o
// conteúdo do painel, nunca a página.
//
//   <Tela titulo sub voltar={{ dica, onClick }} abas={[{ id, rotulo, icone?, qtd?, alerta?, dica? }]} aba onAba acoes>
//     <Painel ativo={aba === 'x'}> … </Painel>
//   </Tela>
//
// `Painel` mantém a aba montada (só escondida): trocar de aba não perde o que
// está sendo montado.
// =============================================
export default function Tela({ titulo, sub, abas, aba, onAba, acoes, voltar, children }) {
  return (
    <div className="tela-c">
      <div className="topo-c">
        <div className="topo-c-titulo">
          {voltar && <button type="button" className="topo-c-voltar" onClick={voltar.onClick} title={voltar.dica} aria-label={voltar.dica}><i className="bi bi-arrow-left"></i></button>}
          <h1 title={typeof titulo === 'string' ? titulo : undefined}>{titulo}</h1>
          {sub && <span>{sub}</span>}
        </div>
        {abas && (
          <div className="abas-c" role="tablist">
            {abas.map(a => (
              <button key={a.id} type="button" role="tab" aria-selected={aba === a.id} className={aba === a.id ? 'ativa' : ''}
                title={a.dica} onClick={() => onAba(a.id)}>
                {a.icone && <i className={`bi bi-${a.icone}`}></i>}
                {a.rotulo}
                {a.qtd != null && <span className={`qtd ${a.alerta ? 'alerta' : ''}`}>{a.qtd}</span>}
              </button>
            ))}
          </div>
        )}
        {acoes && <div className="topo-c-acoes">{acoes}</div>}
      </div>
      {children}
    </div>
  );
}

export function Painel({ ativo = true, children }) {
  return <div className="painel-c" hidden={!ativo}>{children}</div>;
}

// Faixa fina embaixo: legenda/estado à esquerda; atalhos de teclado à direita.
export function Rodape({ children, atalhos }) {
  return (
    <div className="rodape-c">
      <div>{children}</div>
      {atalhos && <div className="atalhos-c">{atalhos.map(([tecla, faz]) => <span key={tecla}><kbd>{tecla}</kbd>{faz}</span>)}</div>}
    </div>
  );
}
